import React, { useEffect, useState } from "react";
import Footer from "../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../Kryzen Alpha App/CustomComponent/toast";
import { useSelector } from "react-redux";
import DynamicFilterInput from "../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import getFilteredURL from "../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../Components/layouts/pagination";
import { FcBiomass, FcWikipedia } from "react-icons/fc";
import { BsBoxArrowInDownRight } from "react-icons/bs";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";
import CustomViedoCard from "../../CustomComponent/custom_viedo_card";
import StepRoutes from "../../Routes/steps_routes";
import EpgProductTable from "./epg_product_table";

const AgronomyPlantsWiki = () => {
  const user = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState({
    startdate: "",
    enddate: "",
    name: "",
  });
  const [page, setPage] = useState(1);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [data, setData] = useState([]);

  useEffect(() => {
    performRequest(
      "GET",
      getFilteredURL("/pmg/product/epg-products/", page, filters)
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.producData);
          setTotalPages(Math.ceil(res.data?.totalCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, [refresh, page]);

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcBiomass className="fs-2 me-1" /> EPG Products Inventory
                </h2>
                <h4 className="text-muted">
                  <StepRoutes></StepRoutes>
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end">
                  {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                  process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                    <a href={"/add-epg-product"}>
                      <button className="btn btn-primary">
                        <BsBoxArrowInDownRight className="me-2 fs-2" />
                        ADD NEW PRODUCT
                      </button>
                    </a>
                  ) : (
                    <></>
                  )}
                     {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                  process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                    <a href={"/add-epg-recipe"}>
                      <button className="btn btn-primary">
                        <BsBoxArrowInDownRight className="me-2 fs-2" />
                        ADD NEW RECIPE
                      </button>
                    </a>
                  ) : (
                    <></>
                  )}
                </div>
              
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card p-2 ">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0 "
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className={`accordion-body pt-0`}>
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Search name:"
                              value={filters.name}
                              onChange={(e) =>
                                setFilters({ ...filters, name: e.target.value })
                              }
                              placeholder="search name..."
                            />
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => setRefresh(!refresh)}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    setFilters({
                                      name: "",
                                      startdate: "",
                                      enddate: "",
                                    });
                                    setPage(1);
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="accordion-body d-none d-md-block ">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) =>
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                })
                              }
                              type="date"
                            />
                          </div>
                          <DynamicFilterInput
                            label="Search name:"
                            value={filters.name}
                            onChange={(e) =>
                              setFilters({ ...filters, name: e.target.value })
                            }
                            placeholder="search name..."
                          />
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    name: "",
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    <div className="accordion-body d-none d-md-block p-1 pt-0">
                      <div className="d-flex align-items-center flex-wrap gap-3">
                        <div className="col-md-2">
                          <DynamicFilterInput
                            label="Start Date:"
                            value={filters.startdate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                startdate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-md-2">
                          <DynamicFilterInput
                            label="End Date:"
                            value={filters.enddate}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                enddate: e.target.value,
                              })
                            }
                            type="date"
                          />
                        </div>

                        <div className="col-md-3">
                          <DynamicFilterInput
                            label="Search Name:"
                            value={filters.name}
                            onChange={(e) =>
                              setFilters({
                                ...filters,
                                name: e.target.value,
                              })
                            }
                            placeholder="Search name..."
                          />
                        </div>

                        <div className="col-md-3">
                          <div className="row">
                            <div className="col-6">
                              <button
                                onClick={() => setRefresh(!refresh)}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>

                            <div className="col-6">
                              <button
                                onClick={() => {
                                  setFilters({
                                    name: "",
                                    startdate: "",
                                    enddate: "",
                                  });
                                  setPage(1);
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <EpgProductTable
                    data={data}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    <div className="btn-list justify-content-end">
                      {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                      process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                        <a href={"/add-epg-product"}>
                          <button className="btn btn-primary">
                            <BsBoxArrowInDownRight className="me-2 fs-2" />
                            ADD NEW PRODUCT
                          </button>
                        </a>
                        
                      ) : (
                        <></>
                      )}
                      {process.env.REACT_APP_ROLE_ADMIN === user.Role ||
                      process.env.REACT_APP_ROLE_ADMIN_S === user.Role ? (
                        <a href={"/add-epg-recipe"}>
                          <button className="btn btn-primary">
                            <BsBoxArrowInDownRight className="me-2 fs-2" />
                            ADD NEW RECIPE
                          </button>
                        </a>
                      ) : (
                        <></>
                      )}
                    </div>
                   
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
              <a
                className="card mt-2 border-0"
                href="https://kryzen.com/farm-training/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="card-body p-0">
                  <img
                    className="d-block d-sm-none"
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752555965/6_cxd8rt_yrqait_yptihc.jpg"
                    alt="plantvisittoday"
                  />
                </div>
              </a>
              <div className="d-block d-md-none d-lg-none">
                <CustomViedoCard
                  viedoLink={"https://www.youtube.com/embed/bVxp0dm4iUs"}
                  id={"model-viedo2"}
                  name={"plant wiki"}
                ></CustomViedoCard>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default AgronomyPlantsWiki;
